import { Cache } from "~/types/cache";

export const useFirstLoginStore = defineStore(Cache.FIRSTLOGIN, () => {
  const firstLogin = ref(false);
  const setFirstLogin = (val: boolean) => {
    firstLogin.value = val;
  };
  return { firstLogin, setFirstLogin };
});
